import React, { Component } from 'react'

export default class Preview extends Component {

    
    render() {
        const {vote, poster, backdrop, title, genre, genreList, rating, overview, release} = this.props;
        
        const listGenre = genre.slice(0,3);

        if (genreList.length) {
            console.log("if es verdaero", genreList)
            listGenre.forEach((e, i) => {
                genreList.some( el => (el.id == e) ? listGenre[i] = el.name : false)
              })

        } else {
            console.log("if es falso", genreList)

        }

        console.log(listGenre)


        return (
        <div className="preview">
            <div className="poster" style = {{backgroundImage : `url("http://image.tmdb.org/t/p/w500/${poster}")`}}>
                <p className="genere">{listGenre.join(" · ")}</p>
            </div>

            <div className="popupPrereview">
                <div className="poster" style = {{backgroundImage : `url("http://image.tmdb.org/t/p/w500/${backdrop}")`}}>
                    <div className="overlay"></div>
                    <span className="fas fa-play"></span>
                    <div className="ratingBox">
                    <p className="rating">{rating}</p>
                        <p className="votes">{vote}<br/> votes</p>
                    </div>
                </div>

                <div className="information">
                    <p className = "title">{title}</p>
                    <p className = "yearAndGenre">{release.split("-")[0]} | {listGenre.join(" · ")}</p>
                    <p className="description">{overview}</p>
                </div>
            </div>
        </div>
        )
    }
}
